<script setup></script>
<template>
  <!-- prettier-ignore   -->
  <div class="flex flex-col w-full items-start justify-center mt-10 mb-10">
    <!-- prettier-ignore   -->
    <div class="flex-1 w-full mx-full mx-auto max-w-[1685px] px-4 
    sm:px-8 lg:px-16">
      <div class="grid gap-8 min-h-80 lg:min-h-100 xl:min-h-120 2xl:min-h-120
      grid-cols-1 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3">
        <!-- 21.05.2026 Нужно вынести иконку независимо от padding для того чтобы была с краю 
          данный код делает не так как нужно распологает элементы-->
        <!-- prettier-ignore   -->
        <!-- <div class="text-black flex items-start justify-start 
        bg-greywhitetop rounded-2xl p-10">
          <div class="flex flex-row justify-between items-start w-full gap-6">
            <div class="max-w-2xl">
              <p>Разработка web-приложений</p>
            </div>
            <div class="flex-shrink-0 w-12 h-12">
              <img src="../../public/svg/vue-dot-js 1.svg">
            </div>
          </div>
        </div> -->
        <!-- Работает тест 21.05.2026 -->
        <div class="relative text-black bg-greywhitetop rounded-2xl p-10
        w-full h-full cursor-pointer">
          <div class="max-w-2xl relative z-10">
            <p class="font-bold text-xl text-[#66A865]">
              Разработка web-приложений
            </p>
          </div>
          <div class="absolute top-2 right-2 w-30 h-30 ">
            <img src="../../public/svg/vue-dot-js 1.svg" class="w-full h-full object-contain">
          </div>
        </div>
        <!-- prettier-ignore   -->
        <div class="relative text-black 
        bg-greywhitetop rounded-2xl p-10 w-full h-full cursor-pointer">
          <div class="max-w-2xl relative z-10">
            <p class="font-bold text-xl">
              Системное администрирование
            </p>
          </div>
          <div class="absolute top-2 right-2 w-30 h-30">
            <img src="../../public/svg/linux 1.svg" class="w-full h-full object-contain">
          </div>  
        </div>
        <!-- prettier-ignore   -->
        <div class="relative text-black  
        bg-greywhitetop rounded-2xl p-10 w-full h-full cursor-pointer">
          <div class="max-2-xl relative z-10">
            <p class="font-bold text-xl text-[#FF0000]">
              Центр компетенций 1С
            </p>
          </div>
          <div class="absolute top-2 right-2 w-30 h-30">
            <img src="../../public/svg/1c-company 1.svg" class="w-full h-full object-contain">
          </div>
        </div>
      </div>
      <!-- prettier-ignore   -->
      <div class="grid gap-8 mt-8 h-72 lg:min-h-72 xl:min-h-80 2xl:min-h-80
      grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-">
        <div class="relative text-black 
        bg-greywhitetop rounded-2xl p-10 w-full h-full cursor-pointer">
          <div class="max-2-xl relative z-10">
            <p class="font-bold text-xl text-[#7072DE]">
              Автоматизация бизнес процессов
            </p>
          </div>
          <div class="absolute top-2 right-2 w-30 h-30">
            <img src="../../public/svg/icons8-automation-100 1.svg">
          </div>
        </div>
        <!-- prettier-ignore   -->
        <div class="relative text-black 
        bg-greywhitetop rounded-2xl p-10 w-full h-full cursor-pointer">
          <div class="max-2-xl releative z-10">
            <p class="font-bold text-xl text-[#854C65]">
              HandBox включен в реестр РКН
            </p>
          </div>
          <div class="absolute top-2 right-2 w-30 h-30">
            <!-- Придумать иконку -->
            <img>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
